/**
 * Checks if the provided argument is a boolean.
 * @param arg - The value to check.
 * @returns True if the argument is a boolean, false otherwise.
 */
export function isBool(arg: unknown): arg is boolean {
  return typeof arg === 'boolean';
}
